<template>
  <v-card outlined class="mb-3 participant-card">
    <v-card-text class="py-3">
      <div class="d-flex align-start justify-space-between">
        <!-- INFO -->
        <div class="flex-grow-1">
          <!-- Nome -->
          <div class="text-subtitle-1 font-weight-medium mb-1">
            {{ participant.name }}
          </div>

          <!-- Chips -->
          <div class="d-flex flex-wrap gap-2 mb-2">
            <v-chip small outlined color="grey darken-1">
              {{ participantTypeLabel }}
            </v-chip>

            <v-chip v-if="typologyLabel" small outlined color="red">
              {{ typologyLabel }}
            </v-chip>
          </div>

          <!-- Contatos -->
          <div
            v-if="hasContacts"
            class="text-caption grey--text text--darken-1 mb-1"
          >
            <span v-if="participant.contact.contact1">
              📞 {{ participant.contact.contact1 }}
            </span>

            <span v-if="participant.contact.contact2" class="ml-3">
              📞 {{ participant.contact.contact2 }}
            </span>

            <span v-if="participant.contact.email" class="ml-3">
              ✉️ {{ participant.contact.email }}
            </span>
          </div>

          <!-- Endereço -->
          <div v-if="addressResume" class="text-caption grey--text">
            📍 {{ addressResume }}
          </div>
        </div>

        <!-- AÇÕES -->
        <div class="d-flex align-center ml-2">
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                icon
                small
                v-bind="attrs"
                v-on="on"
                @click="$emit('edit', participant)"
              >
                <v-icon size="20">mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Alterar dados</span>
          </v-tooltip>

          <v-tooltip bottom v-if="canRemove">
            <template #activator="{ on, attrs }">
              <v-btn
                icon
                small
                v-bind="attrs"
                v-on="on"
                @click="$emit('remove', participant)"
              >
                <v-icon size="20" color="red">mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Remover</span>
          </v-tooltip>

          <v-tooltip bottom v-else>
            <template #activator="{ on, attrs }">
              <v-btn icon small disabled v-bind="attrs" v-on="on">
                <v-icon size="20" color="grey">mdi-lock</v-icon>
              </v-btn>
            </template>
            <span>O segurado não pode ser removido</span>
          </v-tooltip>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: "ParticipantCard",

  props: {
    participant: {
      type: Object,
      required: true,
    },
  },

  computed: {
    participantTypeLabel() {
      return this.participant?.participant_type?.description || "—";
    },

    typologyLabel() {
      const map = {
        house: "Moradia",
        apartment: "Apartamento",
        garage: "Garagem",
        office: "Escritório",
        commercial_room: "Espaço comercial",
        warehouse: "Armazém",
        land: "Terreno",
        building: "Prédio",
      };

      return map[this.participant?.risk_location_typology] || null;
    },

    canRemove() {
      return this.participant?.participant_type?.canonical !== "insured";
    },

    hasContacts() {
      const c = this.participant?.contact;
      return !!(c?.contact1 || c?.contact2 || c?.email);
    },

    addressResume() {
      const a = this.participant?.contact?.address;
      if (!a) return null;

      return [
        a.street,
        a.number,
        a.city?.name,
        a.country_area?.name,
        a.postal_code,
      ]
        .filter(Boolean)
        .join(", ");
    },
  },
};
</script>
<style scoped>
.participant-card {
  transition: background-color 0.15s ease;
}

.participant-card:hover {
  background-color: #fafafa;
}

.gap-2 {
  gap: 8px;
}
</style>
